import * as React from "react";
import "../utils/globals.js";
import { contentDependency } from "../utils/objects.js";
const useContentMemo = (item) => {
  const contentDependencyResult = React.useMemo(() => contentDependency(item), [item]);
  return React.useMemo(() => item, [contentDependencyResult]);
};
export {
  useContentMemo
};
//# sourceMappingURL=useContentMemo.js.map
